import { Link } from "react-router-dom";

export default function ErrorPage() {
  return (
    <div className="container text-center">
      <h1>404</h1>
      <Link to="/">Go Home</Link>
    </div>
  );
}